import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import People from 'src/containers/people';
import Responsibles from 'src/containers/responsibles';
import Layout from 'src/components/layout';
import Needs from 'src/containers/needs';
import Reports from 'src/containers/reports';
import LayoutCanvas from 'src/components/layout-canvas';
import LoginPage from 'src/pages/login';
import AuthRouter from 'src/components/routers/auth-router';
import MockLoginPage from 'src/pages/mock-login';
import PageError from 'src/pages/error';
import { refreshConsul } from 'src/config/load-consul';
import openGlobalAuth from 'src/utils/global-auth';
import { useSelector } from 'react-redux';


/**
 * Routers component - contains all Path Routes with Authorization Guard components.
 * 
 * @returns {JSX.Element} The Routers component.
 * @example
 *  <Routers />
 */
function Routers() {
    /**
     * Only activates `__mock_login` route if it's local or dev env.
     */
    const isLocalEnvOrDev = !['uat', 'prd'].includes(process.env.REACT_APP_ENV);

    const sessionUser = useSelector((state) => state.login.sessionUser);
	const isSessionUserTI = sessionUser.profile === 'TI';

    // loads upon network reload:
    refreshConsul();

    return (
        <Switch>
            <Route path="/" exact>
            {isSessionUserTI ? (
              <Redirect to="/responsibles" />
            ) : (
              <Redirect to="/profile" />
            )}
            </Route>
            <AuthRouter path="/profile">
                <Layout>
                    <People />
                </Layout>
            </AuthRouter>
            <AuthRouter path="/opportunity">
                <Layout>
                    <Needs />
                </Layout>
            </AuthRouter>
            <AuthRouter path="/reports/fit">
                <Layout>
                    <Reports />
                </Layout>
            </AuthRouter>
            <AuthRouter path="/reports/inactivation">
                <Layout>
                    <Reports />
                </Layout>
            </AuthRouter>
            <AuthRouter path="/responsibles">
                <Layout>
                    <Responsibles />
                </Layout>
            </AuthRouter>
            <Route path="/login">
                <LayoutCanvas>
                    <LoginPage />
                </LayoutCanvas>
            </Route>
            { isLocalEnvOrDev && 
                <Route path="/__mock_login">
                    <LayoutCanvas>
                        <MockLoginPage />
                    </LayoutCanvas>
                </Route> 
            }
            <Route path="/error">
                <PageError errorType={'generic'} />
            </Route>
            <Route path="/unauthentication">
                { () => openGlobalAuth() }
            </Route>
            <Route path='*' exact>
                <PageError errorType={'404'} />
            </Route>
        </Switch>
    );
}

export default Routers;
